import { CalendarClock, LayoutDashboard, TrendingUp, Users } from "lucide-react";
import { defineFeature } from "../types";

/**
 * Dashboard — today's money, work and risks in one glance (PRD §7 Item 7).
 *
 * One route, several audiences: the API decides which dashboards the signed-in
 * person may open (owner, account manager, PM, my work, finance) and which one
 * they land on, and `?role=` switches between them. The page itself holds no
 * opinion about who you are — permissions are enforced server-side, and the
 * tile set follows.
 */
export default defineFeature({
  key: "dashboard",
  title: "Dashboard",
  routes: [{ index: true, lazy: () => import("./page") }],
  nav: [
    {
      label: "Dashboard",
      to: "/",
      icon: LayoutDashboard,
      group: "home",
      order: 10,
      end: true,
      description: "Money, work and risks at a glance",
    },
  ],
  commands: [
    { key: "dashboard.finance", label: "Finance dashboard", icon: CalendarClock, to: "/?role=finance", group: "navigate" },
    { key: "dashboard.my_work", label: "My work", icon: Users, to: "/?role=member", group: "navigate" },
    { key: "dashboard.fy", label: "Dashboard for this financial year", icon: TrendingUp, to: "/?period=fy", group: "navigate" },
  ],
});
